export const heroStatement = ['Not a website, a world.', 'Brands built to be explored.'];

export const heroStats = ['Immersive 3D Brand Experience Studio'];

/** Shown in the right-hand slot of the hero's bottom row */
export const heroSocials = [
  { label: 'Instagram', href: 'https://instagram.com' },
  { label: 'LinkedIn', href: 'https://linkedin.com' },
  { label: 'X.com', href: 'https://x.com' },
];
